import { useQuery } from "@tanstack/react-query";
import { getAdminAuditLogs } from "../../service/query/auth";

export const useGetAdminAuditLogs = ({ membership_id, admin_name, action, from, to, page, enabled }) => {
    return useQuery({
        queryKey: ["adminAuditLogs", membership_id, admin_name, action, from, to, page],
        queryFn: () => getAdminAuditLogs({ membership_id, admin_name, action, from, to, page }),
        enabled: !!enabled,
    });
};